import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { DASHBOARD } from '../../constant';

type Args = {
  clinicId: string;
  year: number;
  month: number | 'all';
  /** Explicit range. When both are present the server bills on it instead of month/year. */
  from?: string;
  to?: string;
};

/**
 * Email a clinic's invoice for a period.
 *
 * Only the clinic and period travel — every amount is recomputed server-side, so the
 * client cannot influence what is billed.
 */
export const sendInvoice = createAsyncThunk(
  'dashboard/sendInvoice',
  async (arg: Args, { rejectWithValue }) => {
    try {
      const res = await fetch(DASHBOARD.SEND_INVOICE, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
        body: JSON.stringify(arg),
      });
      const body = await res.json().catch(() => ({}));
      if (!res.ok) {
        return rejectWithValue(body.msg || 'Failed to send invoice');
      }
      return body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
